import { ReferenceDataModel } from './type-data.model';

export interface ActiveFilterItem<T> {
  key: keyof T;
  value: string | boolean | Date | ReferenceDataModel | (string | boolean | Date | ReferenceDataModel)[];
  isMultipleValuesFilter: boolean;
}
